// EV Cable Hub — PDP variant + qty + install + add-to-cart
(function () {
  'use strict';

  function ProductForm(form, productData) {
    this.form = form;
    this.product = productData;
    this.installPrice = window.theme && window.theme.installPrice ? window.theme.installPrice : 0;
    this.installVariantId = window.theme && window.theme.installVariantId ? window.theme.installVariantId : null;
    this.qty = 1;
    this.installAdd = false;
    this.options = [];
    var groups = this.form.querySelectorAll('.variant-group');
    this.groupIndexes = [];
    for (var i = 0; i < groups.length; i++) {
      this.options.push(null);
      var gi = parseInt(groups[i].getAttribute('data-option-index'), 10);
      if (!isNaN(gi)) this.groupIndexes.push(gi);
    }
    this.groupIndexes.sort(function (a, b) { return a - b; });
    this.bind();
    this.syncFromInitial();
  }

  ProductForm.prototype.bind = function () {
    var self = this;
    var swatches = this.form.querySelectorAll('.swatch, .colour-swatch');
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () { self.onSwatch(btn); });
    });
    var inc = this.form.querySelector('[data-qty-increment]');
    var dec = this.form.querySelector('[data-qty-decrement]');
    if (inc) inc.addEventListener('click', function () { self.setQty(self.qty + 1); });
    if (dec) dec.addEventListener('click', function () { self.setQty(Math.max(1, self.qty - 1)); });
    var install = this.form.querySelector('[data-install-toggle]');
    if (install) install.addEventListener('change', function (e) {
      self.installAdd = e.target.checked;
      var label = self.form.querySelector('.install-upsell');
      if (label) label.classList.toggle('is-on', self.installAdd);
      self.update();
    });
    this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
  };

  ProductForm.prototype.syncFromInitial = function () {
    var self = this;
    // A ?variant= link (the registration lookup uses one) is an explicit choice,
    // so honour it in full. Otherwise start with nothing chosen: Shopify marks
    // the first available variant as selected, which would defeat the cascade.
    var wanted = null;
    try {
      var q = new URLSearchParams(window.location.search).get('variant');
      if (q) wanted = (this.product.variants || []).filter(function (v) {
        return String(v.id) === String(q);
      })[0] || null;
    } catch (e) { /* older browsers just start empty */ }

    if (wanted) {
      var arr = [wanted.option1, wanted.option2, wanted.option3];
      for (var i = 0; i < this.options.length; i++) {
        if (arr[i] !== null && arr[i] !== undefined) this.options[i] = arr[i];
      }
    } else {
      // An option with a single value is not a decision, so answer it for them.
      this.groupIndexes.forEach(function (idx) {
        var g = self.form.querySelector('.variant-group[data-option-index="' + idx + '"]');
        var btns = g ? g.querySelectorAll('.swatch, .colour-swatch') : [];
        if (btns.length === 1) self.options[idx] = btns[0].getAttribute('data-option-value');
      });
      // Positions with no group of their own still need a value to match on.
      var first = (this.product.variants || [])[0];
      if (first) {
        var seed = [first.option1, first.option2, first.option3];
        for (var s = 0; s < seed.length; s++) {
          if (this.groupIndexes.indexOf(s) === -1 && seed[s] != null) this.options[s] = seed[s];
        }
      }
    }
    this.update();
  };

  ProductForm.prototype.onSwatch = function (btn) {
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var idx = parseInt(btn.getAttribute('data-option-index'), 10) || 0;
    var value = btn.getAttribute('data-option-value');
    if (this.options[idx] === value) return;
    this.options[idx] = value;

    // Keep what is below if it still works with the new choice, and only ask
    // again for the part that genuinely broke. Clearing everything below on
    // every click made people re-pick a length and a rating they had already
    // chosen and could still have. Once one level is cleared the levels under
    // it depend on an unanswered question, so they go too.
    var self = this;
    var dropping = false;
    this.groupIndexes.forEach(function (g) {
      if (g <= idx) return;
      if (dropping) { self.options[g] = null; return; }
      var held = self.options[g];
      if (held == null) { dropping = true; return; }
      if (!self.isReachable(g, held)) {
        self.options[g] = null;
        dropping = true;
      }
    });
    this.update();
  };

  ProductForm.prototype.setQty = function (n) {
    this.qty = n;
    var disp = this.form.querySelector('[data-qty-display]');
    var input = this.form.querySelector('[data-qty-input]');
    if (disp) disp.textContent = n;
    if (input) input.value = n;
    this.update();
  };


  // Every variant whose option at `idx` equals `value`.
  ProductForm.prototype.withOption = function (idx, value) {
    return (this.product.variants || []).filter(function (v) {
      return [v.option1, v.option2, v.option3][idx] === value;
    });
  };

  // Push this.options back onto the buttons, so a repaired selection is visible.
  ProductForm.prototype.syncDom = function () {
    var self = this;
    this.form.querySelectorAll('.variant-group').forEach(function (g) {
      var idx = parseInt(g.getAttribute('data-option-index'), 10);
      if (isNaN(idx)) return;
      g.querySelectorAll('.swatch, .colour-swatch').forEach(function (s) {
        s.classList.toggle('active', s.getAttribute('data-option-value') === self.options[idx]);
      });
      var sel = self.form.querySelector('[data-selected-value-' + idx + ']');
      if (sel && self.options[idx]) sel.textContent = self.options[idx];
    });
  };

  // Option values do not exist in every combination: the 3-pin cable only comes
  // in the adjustable rating, the Type 2 cable only in 16/32amp. Picking a cable
  // type while an incompatible rating is selected used to match no variant at
  // all, which froze the gallery and showed "Unavailable". Instead, keep the
  // value the customer just clicked and move the other options to the closest
  // combination that really exists, preferring one that is in stock.
  ProductForm.prototype.repair = function (changedIdx) {
    if (this.match()) return;
    var self = this;
    var pool = this.withOption(changedIdx, this.options[changedIdx]);
    if (!pool.length) return;
    var best = null, bestScore = -1;
    pool.forEach(function (v) {
      var arr = [v.option1, v.option2, v.option3], score = 0;
      for (var i = 0; i < self.options.length; i++) {
        if (i !== changedIdx && self.options[i] === arr[i]) score += 2;
      }
      if (v.available) score += 1;
      if (score > bestScore) { bestScore = score; best = v; }
    });
    if (!best) return;
    var arr = [best.option1, best.option2, best.option3];
    for (var i = 0; i < this.options.length; i++) {
      if (arr[i] !== null && arr[i] !== undefined) this.options[i] = arr[i];
    }
    this.syncDom();
  };

  // Mark what cannot be bought, so nobody has to click every option to find out.
  ProductForm.prototype.refreshAvailability = function () {
    var self = this;
    var all = this.product.variants || [];
    this.form.querySelectorAll('.variant-group').forEach(function (g) {
      var idx = parseInt(g.getAttribute('data-option-index'), 10);
      if (isNaN(idx)) return;
      g.querySelectorAll('.swatch, .colour-swatch').forEach(function (s) {
        var val = s.getAttribute('data-option-value');
        var soldOut = !all.some(function (v) {
          return [v.option1, v.option2, v.option3][idx] === val && v.available;
        });
        var fitsHere = all.some(function (v) {
          var arr = [v.option1, v.option2, v.option3];
          if (arr[idx] !== val) return false;
          for (var i = 0; i < self.options.length; i++) {
            if (i === idx || self.options[i] == null) continue;
            if (self.options[i] !== arr[i]) return false;
          }
          return v.available;
        });
        s.classList.toggle('is-unavailable', soldOut);
        s.classList.toggle('is-incompatible', !soldOut && !fitsHere);
        if (soldOut) s.setAttribute('aria-disabled', 'true');
        else s.removeAttribute('aria-disabled');
      });
    });
  };


  // Which cable-type value does this variant carry?
  ProductForm.prototype.cableTypeOf = function (variant) {
    var names = this.product.options || [];
    for (var i = 0; i < names.length; i++) {
      var n = (typeof names[i] === 'string' ? names[i] : (names[i] && names[i].name)) || '';
      if (n.toLowerCase().indexOf('cable type') !== -1) {
        return [variant.option1, variant.option2, variant.option3][i];
      }
    }
    return null;
  };

  // Show what belongs to the chosen variant: this product's own photographs
  // plus the selected variant's image. The reusable stock library is held back,
  // because a column of the same eight catalogue shots on every product tells a
  // buyer nothing about the cable they are actually looking at.
  //
  // Some products carry no imagery of their own, so if that leaves too little to
  // be a gallery we fall back to the library filtered to the selected connector.
  ProductForm.prototype.filterGallery = function (variant) {
    var ct = this.cableTypeOf(variant);
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    if (!thumbs.length) return;

    var vsrc = variant && variant.featured_image && variant.featured_image.src
      ? variant.featured_image.src.split('?')[0] : null;

    var keep = [];
    thumbs.forEach(function (t) {
      var isLib = t.getAttribute('data-library') === '1';
      var tsrc = (t.getAttribute('data-src') || '').split('?')[0];
      var isVariantImage = vsrc && tsrc === vsrc;
      if (!isLib || isVariantImage) keep.push(t);
    });

    if (keep.length < 2) {
      // Nothing product-specific to show: fall back to the connector-matched set.
      keep = [];
      thumbs.forEach(function (t) {
        var tct = t.getAttribute('data-cable-type') || '';
        if (tct === '' || !ct || tct === ct) keep.push(t);
      });
    }

    thumbs.forEach(function (t) {
      t.classList.toggle('is-filtered-out', keep.indexOf(t) === -1);
    });
    var strip = document.querySelector('[data-gallery-thumbs]');
    if (strip) strip.classList.toggle('is-single', keep.length < 2);
  };


  // ── Availability model ────────────────────────────────────────────────
  // Three rules, in order of precedence:
  //   dead      value has no purchasable variant anywhere -> sold out on arrival
  //   locked    an earlier option has not been chosen yet -> not yet pickable
  //   blocked   value exists but not with what is already chosen -> out of stock
  // Nothing invalid is ever clickable, so a later choice can never reach back
  // and silently rewrite an earlier one.

  ProductForm.prototype.optionAt = function (v, i) {
    return [v.option1, v.option2, v.option3][i];
  };

  ProductForm.prototype.anyLive = function () {
    return (this.product.variants || []).some(function (v) { return v.available; });
  };

  // No purchasable variant carries this value, whatever else is picked.
  ProductForm.prototype.isDead = function (idx, value) {
    var self = this;
    return !(this.product.variants || []).some(function (v) {
      return v.available && self.optionAt(v, idx) === value;
    });
  };

  // Purchasable alongside the choices ABOVE this one only.
  //
  // A later choice must never constrain an earlier one. Judging every option
  // against the full selection made options above the one just picked report
  // "out of stock": choose 22kW and 20M went grey, because 20M only exists at
  // 7.2kW. Since picking an option already clears everything below it, the
  // lower value is about to be discarded anyway and has no business
  // disqualifying the value above it.
  //
  // Positions with no group of their own are fixed for the whole product, so
  // they still apply wherever they sit.
  ProductForm.prototype.isReachable = function (idx, value) {
    var self = this;
    return (this.product.variants || []).some(function (v) {
      if (!v.available) return false;
      if (self.optionAt(v, idx) !== value) return false;
      for (var i = 0; i < self.options.length; i++) {
        if (i === idx) continue;
        if (self.options[i] == null) continue;
        if (self.groupIndexes.indexOf(i) !== -1 && i > idx) continue;
        if (self.optionAt(v, i) !== self.options[i]) return false;
      }
      return true;
    });
  };

  // A group opens only once every group before it has an answer.
  ProductForm.prototype.isUnlocked = function (idx) {
    for (var i = 0; i < idx; i++) {
      if (this.groupIndexes.indexOf(i) !== -1 && this.options[i] == null) return false;
    }
    return true;
  };

  ProductForm.prototype.render = function () {
    var self = this;
    var soldOutProduct = !this.anyLive();
    this.form.querySelectorAll('.variant-group').forEach(function (g) {
      var idx = parseInt(g.getAttribute('data-option-index'), 10);
      if (isNaN(idx)) return;
      var unlocked = !soldOutProduct && self.isUnlocked(idx);
      g.classList.toggle('is-locked', !unlocked);
      var hint = g.querySelector('[data-group-hint]');
      if (hint) hint.hidden = unlocked;

      g.querySelectorAll('.swatch, .colour-swatch').forEach(function (s) {
        var val = s.getAttribute('data-option-value');
        var dead = soldOutProduct || self.isDead(idx, val);
        var blocked = !dead && unlocked && !self.isReachable(idx, val);
        var pickable = !dead && !blocked && unlocked;
        s.classList.toggle('is-unavailable', dead);
        s.classList.toggle('is-blocked', blocked);
        s.classList.toggle('is-locked', !unlocked && !dead);
        s.disabled = !pickable;
        s.setAttribute('aria-disabled', pickable ? 'false' : 'true');
        s.classList.toggle('active', self.options[idx] === val && pickable);
      });

      var sel = self.form.querySelector('[data-selected-value-' + idx + ']');
      if (sel) sel.textContent = self.options[idx] || '';
    });
  };

  // The first group still waiting for an answer, or -1 when the set is complete.
  ProductForm.prototype.firstPending = function () {
    for (var i = 0; i < this.groupIndexes.length; i++) {
      var idx = this.groupIndexes[i];
      if (this.options[idx] == null) return idx;
    }
    return -1;
  };

  ProductForm.prototype.groupLabel = function (idx) {
    var g = this.form.querySelector('.variant-group[data-option-index="' + idx + '"]');
    var l = g && g.querySelector('.variant-group-label, legend, .variant-group-head');
    var t = l ? l.textContent.replace(/\s+/g, ' ').trim().replace(/:$/, '') : '';
    return t || 'an option';
  };

  ProductForm.prototype.lowestPrice = function () {
    var live = (this.product.variants || []).filter(function (v) { return v.available; });
    if (!live.length) return null;
    return live.reduce(function (m, v) { return v.price < m ? v.price : m; }, live[0].price);
  };

  // Show a variant's photograph. Split out of update() so a partial selection
  // can preview an image too: choosing a cable type should change the picture
  // straight away, not wait until length and rating are also answered.
  ProductForm.prototype.showVariantImage = function (variant) {
    if (!variant) return;
    // ── Swap the gallery to this variant's own image ──
    // Two faults were visible here. The swap wrote straight to the live <img>,
    // so the browser tore down the old picture and showed nothing until the new
    // one arrived, which read as a slow load. And a fast second click started a
    // second swap while the first was still downloading, so whichever finished
    // last won and the picture could end up on the wrong variant.
    //
    // Now: decode the next image off-screen before it goes on the page, and
    // stamp each swap so a stale one that lands late is thrown away.
    if (variant.featured_image && variant.featured_image.src) {
      var vbase = variant.featured_image.src.split('?')[0];
      var ver = (variant.featured_image.src.split('?')[1] || '').replace(/&?width=\d+/, '');
      var q = ver ? ('?' + ver + '&') : '?';
      var hero = document.querySelector('[data-gallery-hero] img');
      var srcset = vbase + q + 'width=600 600w, ' + vbase + q + 'width=1000 1000w, ' +
                   vbase + q + 'width=1400 1400w, ' + vbase + q + 'width=2000 2000w';
      var src = vbase + q + 'width=1400';

      if (hero && hero.getAttribute('src').split('?')[0] !== vbase) {
        var token = (this._swap = (this._swap || 0) + 1);
        var self2 = this;
        var apply = function () {
          if (self2._swap !== token) return;   // a newer click already won
          hero.setAttribute('srcset', srcset);
          hero.setAttribute('src', src);
          if (variant.featured_image.alt) hero.setAttribute('alt', variant.featured_image.alt);
          hero.classList.remove('is-swapping');
        };
        var pre = new Image();
        pre.srcset = srcset;
        pre.sizes = hero.getAttribute('sizes') || '(min-width: 1024px) 60vw, 100vw';
        pre.src = src;
        hero.classList.add('is-swapping');
        if (pre.decode) pre.decode().then(apply).catch(apply);
        else if (pre.complete) apply();
        else { pre.onload = apply; pre.onerror = apply; }
      }
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        var tb = (t.getAttribute('data-src') || '').split('?')[0];
        t.classList.toggle('active', tb === vbase);
      });
    }

  };

  // The first purchasable variant agreeing with every answer given so far.
  ProductForm.prototype.bestPartial = function () {
    var self = this;
    var pool = (this.product.variants || []).filter(function (v) {
      if (!v.available) return false;
      for (var i = 0; i < self.options.length; i++) {
        if (self.options[i] == null) continue;
        if (self.optionAt(v, i) !== self.options[i]) return false;
      }
      return true;
    });
    return pool[0] || null;
  };

  ProductForm.prototype.match = function () {
    if (!this.product.variants) return null;
    var opts = this.options;
    return this.product.variants.find(function (v) {
      var arr = [v.option1, v.option2, v.option3];
      for (var i = 0; i < opts.length; i++) {
        if (opts[i] === null || opts[i] === undefined) continue;
        if (opts[i] !== arr[i]) return false;
      }
      return true;
    });
  };

  ProductForm.prototype.update = function () {
    var variant = this.match();
    var idInput = this.form.querySelector('[data-variant-id]');
    var submit = this.form.querySelector('[data-add-to-cart]');
    var scope = this.form.closest('.buy-panel') || this.form.parentElement || document;
    var price = scope.querySelector('[data-price]');
    var compareAt = scope.querySelector('[data-compare-at]');
    var klarna = scope.querySelector('[data-klarna]');
    var totalEl = this.form.querySelector('[data-total-price]');

    this.render();

    var pending = this.firstPending();
    if (pending !== -1 || !variant) {
      if (price) {
        var low = this.lowestPrice();
        price.textContent = low == null ? 'Sold out'
          : 'From ' + window.theme.formatMoney(low);
      }
      if (compareAt) compareAt.style.display = 'none';
      if (submit) {
        submit.disabled = true;
        if (!this.anyLive()) submit.textContent = 'Sold out';
        else if (pending !== -1) submit.textContent = 'Choose ' + this.groupLabel(pending).toLowerCase();
        else submit.textContent = 'Unavailable';
      }
      // Still preview the picture for whatever has been chosen so far.
      var partial = this.bestPartial();
      this.showVariantImage(partial);
      this.filterGallery(partial || {});
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (submit) submit.disabled = !variant.available;
    if (price) price.textContent = window.theme.formatMoney(variant.price);
    if (klarna) klarna.textContent = window.theme.formatMoney(Math.round(variant.price / 4));
    if (compareAt) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareAt.textContent = window.theme.formatMoney(variant.compare_at_price);
        compareAt.style.display = '';
      } else {
        compareAt.style.display = 'none';
      }
    }
    this.showVariantImage(variant);
    this.filterGallery(variant);

    var total = (variant.price + (this.installAdd ? this.installPrice : 0)) * this.qty;
    if (totalEl) totalEl.textContent = window.theme.formatMoney(total);
    if (submit) {
      if (variant.available) {
        submit.innerHTML = 'Add to bag · <span class="ticker" data-total-price>' + window.theme.formatMoney(total) + '</span>';
      } else {
        submit.textContent = 'Sold out';
      }
    }
  };

  ProductForm.prototype.onSubmit = function (e) {
    e.preventDefault();
    var self = this;
    var idInput = this.form.querySelector('[data-variant-id]');
    var id = idInput ? parseInt(idInput.value, 10) : null;
    if (!id) return;
    var items = [{ id: id, quantity: this.qty }];
    if (this.installAdd && this.installVariantId) {
      items.push({ id: this.installVariantId, quantity: this.qty });
    }
    // Accessories: only added when the customer picks one. The "no add ons"
    // radio carries an empty value, so nothing is appended by default.
    var addon = this.form.querySelector('input[name="addon"]:checked');
    if (addon && addon.value) {
      items.push({ id: parseInt(addon.value, 10), quantity: 1 });
    }
    var submit = this.form.querySelector('[data-add-to-cart]');
    if (submit) submit.disabled = true;
    fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      if (submit) {
        submit.disabled = false;
        var orig = submit.innerHTML;
        submit.innerHTML = '✓ Added to bag';
        setTimeout(function () { self.update(); }, 1800);
      }
    }).catch(function () {
      if (submit) submit.disabled = false;
    });
  };

  // Pull each variant's photograph into cache while the page is idle, so the
  // first click on a swatch paints from cache instead of starting a download.
  function prefetchVariantImages(data) {
    var seen = {};
    (data.variants || []).forEach(function (v) {
      if (!v.featured_image || !v.featured_image.src) return;
      var base = v.featured_image.src.split('?')[0];
      if (seen[base]) return;
      seen[base] = 1;
      var ver = (v.featured_image.src.split('?')[1] || '').replace(/&?width=\d+/, '');
      var q = ver ? ('?' + ver + '&') : '?';
      var im = new Image();
      im.srcset = base + q + 'width=600 600w, ' + base + q + 'width=1000 1000w, ' +
                  base + q + 'width=1400 1400w';
      im.src = base + q + 'width=1400';
    });
  }

  function init() {
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      var pid = form.getAttribute('data-product-id');
      var script = document.getElementById('ProductJson-' + pid);
      if (!script) return;
      try {
        var data = JSON.parse(script.textContent);
        /* Expose the instance so the direction-G variant cascade can drive it.
           The cascade owns option STATE (which values are selected, and the
           four visual states); this class still owns everything downstream of
           a resolved variant - price, Klarna, compare-at, the running total,
           the gallery swap and the add-to-cart AJAX. Handing it the selection
           keeps one renderer rather than two fighting over the same nodes. */
        form.__productForm = new ProductForm(form, data);
        var warm = function () { prefetchVariantImages(data); };
        if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 2500 });
        else setTimeout(warm, 1200);
      } catch (e) { /* noop */ }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
